/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespIconBubbles_user$ref = any;
type PdpRespTradeIconBubbles_user$ref = any;
export type PdpRespIconBubblesWrapper_user$ref = any;
export type PdpRespIconBubblesWrapper_user = {
    readonly " $fragmentRefs": PdpRespIconBubbles_user$ref & PdpRespTradeIconBubbles_user$ref;
    readonly " $refType": PdpRespIconBubblesWrapper_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespIconBubblesWrapper_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_user",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '19f3057534586ba1d5fd5bcf9624e8ef';
export default node;
